export default __webpack_public_path__ + "static/media/bg-light5@2x.31055266.jpg";